export class VodiaRequest {
  constructor({
    method = null,
    type = null,
    domainName = null,
    identifier = null,
    content = {},
    formerContent = {},
    dealer = null,
    session = null,
    ip = null
  } = {}) {
    this.method = method;
    this.type = type;
    this.domainName = domainName;
    this.content = content;
    this.identifier = identifier;
    this.formerContent = formerContent;
    this.dealer = dealer;
    this.session = session;
    this.ip = ip;
  }
}

export function createVodiaRequest(data) {
  return Object.freeze(new VodiaRequest(data));
}
